<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal size="md"
                   :visible="modal.show"
                   :data="model"
                   :title="model.uuid ? $t('Edit Trust Level') : $t('Add Trust Level')"
                   @hidden="onHidden"
                   @show="onShow"
                   @ok.prevent="handleSubmit(onSubmit)"
                   :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')"
                   :is-loading="loading"
                   scrollable>
      <div class="trust-level-tiers">
        <div class="row">
          <div class="col-md-12">
            <input-widget :model="model" attribute="name"/>
          </div>
          <div class="col-md-12">
            <currency-input-widget :model="model" attribute="credit_limit" type="number"/>
          </div>
          <div class="col-md-12">
            <currency-input-widget :model="model" attribute="threshold" type="number"/>
          </div>

          <div class="col-md-12">
            <input-widget :model="model" attribute="exclude_from_auto_assignment" type="checkbox"
                          :is-switch="true"/>
          </div>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import TrustLevel from "./TrustLevel.model";
  import InputWidget from "../../../../../core/components/input-widget/InputWidget.vue";
  import ArtisioModal from "../../../../../core/components/artisio-modal/ArtisioModal.vue";
  import CurrencyInputWidget from "../../../../../core/widgets/CurrencyInputWidget.vue";


  const {mapState, mapActions, mapMutations} = createNamespacedHelpers('setup/branch');
  export default {
    name: "TrustLevelTierModal",
    components: {CurrencyInputWidget, ArtisioModal, InputWidget},
    data() {
      return {
        loading: false,
        showConfirmation: true,
        model: new TrustLevel(),
      }
    },
    methods: {
      ...mapActions(['updateTrustLevel', 'createTrustLevel']),
      ...mapMutations(['hideTrustLevelModal']),
      onShow() {
        this.showConfirmation = true;
      },
      onHidden() {
        this.model = new TrustLevel();
        this.selectedLanguages = [];
        this.hideTrustLevelModal();
      },
      async onSubmit() {
        const data = {
          name: this.model.name,
          credit_limit: this.model.credit_limit,
          threshold: this.model.threshold,
          branch_uuid: this.branch.uuid,
          exclude_from_auto_assignment: this.model.exclude_from_auto_assignment
        };

        let response = null;
        this.loading = true;

        if (!this.model.uuid) {
          response = await this.createTrustLevel(data);
        } else {
          response = await this.updateTrustLevel({...data, uuid: this.modal.object.uuid});
        }
        this.loading = false;

        if (response.success) {
          this.showConfirmation = false;
          this.hideTrustLevelModal();
          this.$toast('success', this.model.uuid ? this.$t('Trust Level successfully updated') : this.$t('Trust Level successfully added'));
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            if (response.body.non_field_errors) {
              this.$errorDialog(response.body.non_field_errors[0]);
            } else {
              this.model.setMultipleErrors(response.body);
            }
          }
        }
      }
    },
    computed: {
      ...mapState({
        modal: state => state.trustLevelsModal,
        editObject: state => state.trustLevelsModal.object,
        branch: state => state.selectedBranch
      })
    },
    watch: {
      editObject() {
        if (this.editObject && this.editObject.uuid) {
          this.model = this.editObject;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .trust-levels-tiers {
    .form-group {

    }
  }
</style>
